import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Tooltip } from "antd";

/**
 * 京东平台标签组件
 * 包含所有京东相关的标签逻辑
 */
export default function useJdTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.JD_FULFILLMENT)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important icon-jd-fulfillment"
                key={OrderTag.JD_FULFILLMENT}
                orderTag={OrderTag.JD_FULFILLMENT}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_TRY_BEFORE_PAY_LATER)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-unimportant"
                key={OrderTag.JD_TRY_BEFORE_PAY_LATER}
                orderTag={OrderTag.JD_TRY_BEFORE_PAY_LATER}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_DELIVERY)) {
        icons.push(
            <Tooltip
                title="京配订单，请用京东系物流商（京东快递、京东快运、京东大件等）打印发货"
                key={OrderTag.JD_DELIVERY}
            >
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.JD_DELIVERY} />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_PACKING_LIST_REQUIRED)) {
        icons.push(
            <Tooltip
                title="该订单需要打印配送清单，请到京东商家后台打印配货清单"
                key={OrderTag.JD_PACKING_LIST_REQUIRED}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JD_PACKING_LIST_REQUIRED}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_HOME_DELIVERY_BULKY)) {
        icons.push(
            <Tooltip
                key={OrderTag.JD_HOME_DELIVERY_BULKY}
                title={<span>大件送货上门：请提供送货上门服务，如买家投诉可能会被平台处罚</span>}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JD_HOME_DELIVERY_BULKY}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_HOME_DELIVERY_LIGHT)) {
        icons.push(
            <Tooltip
                key={OrderTag.JD_HOME_DELIVERY_LIGHT}
                title={<span>中小件送货上门：请使用京东无界已支持送货上门服务的快递进行打印、发货</span>}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JD_HOME_DELIVERY_LIGHT}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_ENCRYPTED_OUT_ORDER_DOUDIAN)) {
        icons.push(
            <Tooltip
                key={OrderTag.JD_ENCRYPTED_OUT_ORDER_DOUDIAN}
                title={<span>该订单为云交易抖店加密订单，请使用抖音电子面单打印</span>}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JD_ENCRYPTED_OUT_ORDER_DOUDIAN}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_ENCRYPTED_OUT_ORDER_KWAI)) {
        icons.push(
            <Tooltip
                key={OrderTag.JD_ENCRYPTED_OUT_ORDER_KWAI}
                title={<span>该订单为云交易快手加密订单，请使用快手电子面单打印</span>}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JD_ENCRYPTED_OUT_ORDER_KWAI}
                />
            </Tooltip>,
        );
    }

    if (orderTagSet.has(OrderTag.JD_CONSOLIDATION_XINJIANG)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.JD_CONSOLIDATION_XINJIANG}
                orderTag={OrderTag.JD_CONSOLIDATION_XINJIANG}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_DELIVERY_APPOINTMENT)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.JD_DELIVERY_APPOINTMENT}
                orderTag={OrderTag.JD_DELIVERY_APPOINTMENT}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_PURCHASE)) {
        icons.push(
            <OrderTagWrap
                className="order-icon icon-important"
                key={OrderTag.JD_PURCHASE}
                orderTag={OrderTag.JD_PURCHASE}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_HYPERLINK_ORDER)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.JD_HYPERLINK_ORDER}
                className="order-icon icon-important"
                orderTag={OrderTag.JD_HYPERLINK_ORDER}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_HYPERLINK_SUBSIDY_ORDER)) {
        icons.push(
            <OrderTagWrap
                key={OrderTag.JD_HYPERLINK_SUBSIDY_ORDER}
                className="order-icon icon-important"
                orderTag={OrderTag.JD_HYPERLINK_SUBSIDY_ORDER}
            />,
        );
    }

    if (orderTagSet.has(OrderTag.JD_PET_ITEM)) {
        icons.push(
            <Tooltip
                styles={{ body: { width: "260px" } }}
                key={OrderTag.JD_PET_ITEM}
                title={<span>安心宠订单请到京麦商家后台进行处理</span>}
            >
                <OrderTagWrap className="order-icon icon-important" orderTag={OrderTag.JD_PET_ITEM} />
            </Tooltip>,
        );
    }

    return icons;
}
